import type { ReactNode } from 'react'

/** Large, light title in the brand typeface, as on pebro's marketing surfaces. */
export function PageHeader({ title, subtitle, action }: { title: string; subtitle?: string; action?: ReactNode }): JSX.Element {
  return (
    <div className="flex flex-wrap items-end justify-between gap-x-4 gap-y-3">
      <div>
        <h1 className="font-brand text-[2rem] font-light leading-tight tracking-tight text-label md:text-[2.5rem]">{title}</h1>
        {subtitle && <p className="mt-0.5 text-small text-label2/60">{subtitle}</p>}
      </div>
      {action}
    </div>
  )
}
